import styled from 'styled-components';
import Pagination from '../Pagination';

const PanelContainer = styled.div`
  display: none;
  margin-top: 32px;

  &.active {
    display: block;
  }
`;

const Table = styled.table(({ theme, columns }) => {
  const { color, type } = theme;

  return `
    display: grid;
    grid-template-columns: min-content repeat(${columns - 2}, 1fr) min-content;

    tr,
    thead,
    tbody {
      display: contents;
    }

    th,
    td {
      text-align: left;
      border-bottom: 1px solid ${color.grayscale[800]};
      padding: 0 16px 12px;

      &:last-child {
        text-align: right;
      }
    }

    th {
      color: ${color.grayscale[200]};
      font-size: ${type.size.tiny};
    }

    td {
      font-size: ${type.size.small};
      padding: 20px 16px 25px;
      color: ${color.grayscale[0]};

      &:nth-child(3) {
        color: ${color.secondary.regular};
        font-weight: bold;
      }
    }
  `;
});

const CheckboxContainer = styled.div`
  padding: 1rem 0;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`;

const CheckboxLabel = styled.label`
  margin: 0 0 0 0.5rem;
`;

const Panel = ({ active, panelData, updateCallback }) => {
  const { columns, count, standings, typeId, page } = panelData;

  const handleDailyChange = (e) => {
    updateCallback(1, e.target.checked);
  };

  return (
    <PanelContainer
      className={active ? 'active' : ''}
      tabIndex={active ? -1 : ''}
      role="tabpanel"
      id={`tournament-panel-${typeId}`}
      aria-labelledby={`tournament-tab-${typeId}`}
    >
      {standings.length ? (
        <Table columns={columns.length}>
          <thead>
            <tr>
              {columns.map((column) => {
                return <th key={`${typeId}-${column.display}`}>{column.display === 'rank' ? '#' : column.display}</th>;
              })}
            </tr>
          </thead>

          <tbody>
            {standings.map((standing, standingIndex) => {
              return (
                <tr key={`${typeId}-${standingIndex}`}>
                  {standing.map((column, columnIndex) => {
                    return <td key={`${typeId}-${standingIndex}-${columnIndex}`}>{column}</td>;
                  })}
                </tr>
              );
            })}
          </tbody>
        </Table>
      ) : (
        <div>No results available</div>
      )}

      <CheckboxContainer>
        <input type="checkbox" id={`daily-standings-${typeId}`} onChange={handleDailyChange} />
        <CheckboxLabel htmlFor={`daily-standings-${typeId}`}>Show Today's Leaderboard</CheckboxLabel>
      </CheckboxContainer>

      <Pagination currentPage={page + 1} total={count} callback={updateCallback} />
    </PanelContainer>
  );
};

export default Panel;
